export const statusCampaignValidator = (status) =>
  ['', 'active', 'draft', 'finished', 'scheduled', 'industry_proposal', 'industry_rejected', 'expired', 'processing'].includes(status?.toLowerCase())
export const statusCampaignArrayValidator = (statusArray) => statusArray.every((status) => statusCampaignValidator(status))
